// extracted by mini-css-extract-plugin
export var root = "CloseButton-module--root--668c1";